export enum PrivateOutdoorSpaces {
    Any = 206,
    Balcony = 208,
    Deck = 3806,
    Garden = 209,
    Greenhouse = 3807,
    Patio = 211,
    PrivateRoofAccess = 212,
    RoofDeck = 3808,
    RoofRights = 3809,
    Terrace = 213,
    None = 207
}